<template>
  <span v-html="dates" />
</template>

<script>
import moment from "moment";
export default {
  name: "ScheduleDatesInterval",
  props: {
    schedule: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    dates() {
      if (!this.schedule) return "";
      const fmt = "DD.MM.yyyy";
      const dates = [...(this.schedule.dates || [])];
      dates.sort();
      let dtb = this.schedule.dt_begin || "";
      let dte = this.schedule.dt_end || "";
      if (dates.length) {
        dtb = dates[0];
        dte = dates[dates.length - 1];
      }
      if (!dte && dtb) {
        return `с ${moment(dtb).format(fmt)}`;
      } else if (dte && !dtb) {
        return `по ${moment(dte).format(fmt)}`;
      } else if (dte && dtb) {
        if (dte == dtb) {
          return moment(dtb).format(fmt);
        } else {
          return `${moment(dtb).format(fmt)}&nbsp;– ${moment(dte).format(fmt)}`;
        }
      } else {
        return "Каждый день";
      }
    }
  }
};
</script>
